import { render, staticRenderFns } from "./chartGrade.vue?vue&type=template&id=4e49dd67&scoped=true&"
import script from "./chartGrade.vue?vue&type=script&lang=js&"
export * from "./chartGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e49dd67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e49dd67')) {
      api.createRecord('4e49dd67', component.options)
    } else {
      api.reload('4e49dd67', component.options)
    }
    module.hot.accept("./chartGrade.vue?vue&type=template&id=4e49dd67&scoped=true&", function () {
      api.rerender('4e49dd67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/overview/chartGrade.vue"
export default component.exports